<template>
  <header class="mdc-top-app-bar mdc-top-app-bar--dense app-bar-bg">
    <div class="mdc-top-app-bar__row">
      <img src="/static/img/Logo-white.svg" class="logo">
      <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end" role="toolbar">
        <mdc-button :href="`${appUrl}/#/signin`" style="color:white;">Login</mdc-button>
        <round-button hasSlot :background="'transparent'" :href="`${appUrl}/#/signup`" style="color:white; background-color:transparent !important; border:2px solid white !important;height: 28px;" elevated>
          <span style="margin-left:6px;">Join <span class="desktoponly">Now</span></span>
        </round-button>
      </section>
    </div>
  </header>
</template>

<script>
import RoundButton from '../components/RoundButton'
import { appUrl } from '../settings'

export default {
  data () {
    return {
      appUrl
    }
  },
  components: {
    RoundButton
  }
}
</script>

<style>
.mdc-top-app-bar--dense .mdc-top-app-bar__row {
  align-items: center;
}
.app-bar-bg {
  background: linear-gradient(0.23deg, #C10457 0%, #730027 100%);
  position: relative;
  width: 100%;
}
.logo-wrapper {
  width: 100%;
  align-items: middle;
}
.logo {
  max-width: 100px;
  margin-left: 15px;
}
.logo.mobileonly {
  max-width: 40px;
  max-height: 40px;
}
.logo-img {
  max-height: 3rem;
  cursor: pointer;
}
@media all and (min-width: 570px) {
  .mobileonly {
    display: none !important;
  }
}
@media all and (max-width: 570px) {
  .desktoponly {
    display: none !important;
  }
  .main-wrapper {
    padding-left: 16px;
    padding-right: 16px;
  }
}
</style>
